import { DRIFT_CHAT_BIONIC_MESSAGES_CATEGORIES_DIMENSIONS } from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const CategoryCountsQuery: CubeQuery = {
  name: 'BionicMessageCategoryCounts',
  query: {
    measures: [DRIFT_CHAT_BIONIC_MESSAGES_CATEGORIES_DIMENSIONS.CATEGORY_COUNT],
    dimensions: [
      DRIFT_CHAT_BIONIC_MESSAGES_CATEGORIES_DIMENSIONS.CATEGORY_NAME,
      DRIFT_CHAT_BIONIC_MESSAGES_CATEGORIES_DIMENSIONS.SCENARIO_NAME,
    ],
  },
  queryName: 'BionicMessageCategoryCounts',
}

export const CategoryRankingsQuery: CubeQuery = {
  name: 'BionicMessageCategoryRankings',
  query: {
    measures: [
      DRIFT_CHAT_BIONIC_MESSAGES_CATEGORIES_DIMENSIONS.CATEGORY_COUNT,
      DRIFT_CHAT_BIONIC_MESSAGES_CATEGORIES_DIMENSIONS.ACCEPTED_COUNT,
      DRIFT_CHAT_BIONIC_MESSAGES_CATEGORIES_DIMENSIONS.REJECTED_COUNT,
      DRIFT_CHAT_BIONIC_MESSAGES_CATEGORIES_DIMENSIONS.NOT_REVIEWED_COUNT,
    ],
    dimensions: [
      DRIFT_CHAT_BIONIC_MESSAGES_CATEGORIES_DIMENSIONS.CATEGORY_NAME,
      DRIFT_CHAT_BIONIC_MESSAGES_CATEGORIES_DIMENSIONS.SCENARIO_NAME,
    ],
  },
  queryName: 'BionicMessageCategoryRankings',
}
